import {
  Block,
  LabelLarge,
  LabelXSmall,
  ParagraphSmall,
  useStyletron,
} from "@mezo-org/mezo-clay"
import { useField } from "formik"

import {
  RootState,
  selectTokenBalance,
  selectTokenDecimals,
  useDappSelector,
} from "#/redux-state"
import { FRIENDLY_DECIMALS_AMOUNT } from "#/shared/constants"
import { useTokenUsdPrice } from "#/shared/hooks"
import { SwapFormField } from "#/shared/types"
import { bigIntToHumanReadableFormat, floatToBigInt } from "#/shared/utils"

import SwapModalTokenInput from "./SwapModalTokenInput"

type SwapModalInputProps = {
  label: string
  fieldName: SwapFormField
  onOpenAssetSelector: () => void
}

export default function SwapModalInput({
  label,
  fieldName,
  onOpenAssetSelector,
}: SwapModalInputProps) {
  const [, metaToken] = useField(`${fieldName}.token`)
  const [, metaAmount, helpersAmount] = useField(`${fieldName}.amount`)

  const tokenDecimals = useDappSelector((state: RootState) =>
    selectTokenDecimals(state, metaToken.value),
  )

  const tokenBalance = useDappSelector((state: RootState) =>
    selectTokenBalance(state, metaToken.value),
  )

  const [css, theme] = useStyletron()

  const { getTokenUsdValueLabel } = useTokenUsdPrice()

  return (
    <Block
      className={css({
        width: "100%",
        padding: theme.sizing.scale600,
        border: `1px solid ${theme.colors.borderOpaque}`,
        borderRadius: theme.borders.radius500,
      })}
    >
      <Block
        className={css({
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
        })}
      >
        <LabelLarge>{label}</LabelLarge>
        <LabelXSmall>
          Balance:{" "}
          {bigIntToHumanReadableFormat(
            tokenBalance,
            Number(tokenDecimals),
            FRIENDLY_DECIMALS_AMOUNT,
          )}
        </LabelXSmall>
      </Block>
      <SwapModalTokenInput
        value={metaAmount.value}
        token={metaToken.value}
        hasError={!!metaAmount.error}
        onInputChange={(e) => helpersAmount.setValue(e.target.value)}
        onOpenAssetSelector={onOpenAssetSelector}
      />
      <ParagraphSmall>{metaAmount.error}</ParagraphSmall>
      <LabelXSmall color={theme.colors.contentSecondary}>
        ~ $
        {getTokenUsdValueLabel(
          floatToBigInt(metaAmount.value, Number(tokenDecimals)),
          metaToken.value,
          Number(tokenDecimals),
        )}
      </LabelXSmall>
    </Block>
  )
}
